export default "__VITE_ASSET__d332bdb3__"